



































































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';
import { handleCompleteTask } from '@/utils/start-guide';

import BusinessService from '@/api/BusinessService';

import { EStartGuideTaskSlug, StartGuideTask } from '@/models/start-guide';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';
import { IBusinessType } from '@/models/business';
import flagKeys from '@/constants/flagKeys';
import { EProgramStatusStatus } from '@/models/program-status';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton
  }
})
export default class EnableSellCoins extends Vue {
  @Prop() task?: StartGuideTask;
  @Prop() onConfirm!: () => void;

  businessService = new BusinessService();
  coinRewardPercentage: string = this.$store.getters[
    'business/getBusinessState'
  ].coinRewardPercentage;
  coinRewardStatus: string = this.$store.getters['business/getRewardStatus']
    ? this.$store.getters['business/getRewardStatus'].rewardStatus
    : null;
  loading: boolean = false;
  IBusinessType = IBusinessType;
  EProgramStatusStatus = EProgramStatusStatus;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleLeftButton() {
    if (this.isDashboardSellCoinsAndLoyaltVerify()) {
      this.$router.push('/sell-coins/campaign/create');
    }
    eventBus.$emit('closeModal');
  }

  formatNumber(number: string) {
    const num = parseFloat(number);
    return num % 1 === 0 ? Math.floor(num) : num.toFixed(2);
  }

  isDashboardSellCoinsAndLoyaltVerify() {
    return this.flags.includes(flagKeys.dashboardSellCoinsAndLoyaltVerify);
  }

  mounted() {
    window.addEventListener('popstate', () => {
      this.handleClose();
    });
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  async enableSellCoinsFromStartGuide() {
    await this.businessService.updateSellCoins(
      true,
      DashboardScreen.StartGuide
    );
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  async handleUpdateBusiness() {
    const { status, data } = await this.businessService.getBusinessInfo();

    if (status !== 200) return;

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...data,
      manager: data.loggedInManager
    });
  }

  async startGuideHandleConfirm() {
    this.loading = true;

    await this.businessService.updateSellCoins(
      true,
      DashboardScreen.StartGuide
    );

    handleCompleteTask(EStartGuideTaskSlug.SELL_COINS);

    await this.handleUpdateBusiness();

    this.onConfirm();
    this.loading = false;
    this.handleClose();
  }

  async handleConfirm() {
    this.loading = true;
    this.onConfirm();
    this.loading = false;
    this.handleClose();
  }

  get tPrefix() {
    return 'sellCoins.modals';
  }
}
